"use client";
export enum UserRole {
  ADMIN = "admin",
  SUPERADMIN = "superadmin",
  PROJECT_MANAGER = "project-manager",
  TASK_MANAGER = "task-manager",
}
